import { Input } from '@design-system/components/input/input';
import { Tag } from '@design-system/components/tag/tag';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';

export const Equipment = ({
  disabled,
  value,
  onChange,
  error,
}: {
  disabled: boolean;
  value?: string;
  onChange: (value: string) => void;
  error?: string;
}) => {
  const [newValue, setNewValue] = useState<string>('');
  const equipmentArr = !value ? [] : value.split(',');

  const onKeyDown = (ev: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      ev.key === 'Enter' &&
      value &&
      newValue &&
      value.toLowerCase().includes(newValue.toLowerCase())
    ) {
      setNewValue('');
      return;
    }
    if (ev.key === 'Enter' && newValue) {
      onChange(!value ? newValue : value.concat(`,${newValue}`));
      setNewValue('');
      return;
    }
  };

  const onRemove = (label: string) => {
    onChange(equipmentArr.filter((i) => i !== label).join(','));
  };

  return (
    <div className="flex flex-col gap-2">
      <Input
        label="Equipment"
        disabled={disabled}
        value={newValue}
        onChange={(ev) => setNewValue(ev.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Write equipment"
        error={error}
      />
      <div className="flex flex-wrap gap-2">
        {equipmentArr.map((label) => (
          <Tag
            label={label}
            key={label}
            endIcon={faXmark}
            onClick={() => onRemove(label)}
            endIconClassName="font-black"
          />
        ))}
      </div>
    </div>
  );
};
